import { areAddressesTheSame } from "@insite/client-framework/Common/CustomerSelectors";
import
{
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { updateShipTo } from "@insite/client-framework/Services/CustomersService";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTo";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { AddOrUpdateShipTo,chain,LoadCart,UpdateBillTo,ValidateBillingAddress} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SaveShipping";
import validateBillingAddressForm from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/ValidateBillingAddressForm";
import translate from "@insite/client-framework/Translate";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain,
    UpdateBillTo ,
    props => {

        const {
            getState,
            apiParameter: { cart },
        } = props;

        const billTo = getBillToState(getState(), cart.billToId).value;
        if (!billTo) {
            throw new Error("There was no billTo loaded for the current cart");
        }
        props.updatedBillTo = billTo;

    },
 );

 replaceInChain(chain,
    LoadCart,
    props => {
        const {            
            apiParameter: { cart },
        } = props;

        const cartId = cart.id;
        if (cartId) {
            props.dispatch(loadCart({ cartId, getPromotions: true }));
        } else {
            props.dispatch(loadCurrentCart({ getPromotions: true }));
        }
    },
 );
 
replaceInChain(
    chain,
    ValidateBillingAddress,
    async props =>
{
    const addressFieldsDataView = getAddressFieldsDataView(props.getState());
    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateBillingAddressForm>[0], boolean>(
        validateBillingAddressForm,
    );
    if(addressFieldsDataView.value !== undefined && addressFieldsDataView.value != null)
    {
        const isBillingAddressValid = await awaitableValidate({
            address: props.updatedBillTo,
            validation: props.updatedBillTo.validation!,
            fieldDisplay: addressFieldsDataView.value!.shipToAddressFields,
        })(props.dispatch, props.getState);
    
        const {
            context: {
                session: { fulfillmentMethod },
            },
            pages: {
                onePageCheckout: { billingAddressFormState, shippingAddressFormState, isBillingAddressTheSameAsShipping },
            },
        } = props.getState();
        if (!isBillingAddressValid && isBillingAddressTheSameAsShipping && fulfillmentMethod === FulfillmentMethod.Ship) {
            const billingFormErrors = billingAddressFormState?.formErrors;
            const shippingFormErrors = { ...shippingAddressFormState?.formErrors };
            billingFormErrors &&
                shippingFormErrors &&
                Object.keys(billingFormErrors).forEach(key => {
                    shippingFormErrors[key] = `${billingFormErrors[key]} ${translate("for billing")}`;
                });
            props.dispatch({
                type: "Pages/OnePageCheckout/SetShippingAddressFormErrors",
                formErrors: shippingFormErrors,
            });
            props.dispatch({
                type: "Pages/OnePageCheckout/CompleteSaveShipping",
            });
    
            return false;
        }
    
        props.dispatch({
            type: "Pages/OnePageCheckout/SetIsBillingAddressUpdateRequired",
            isBillingAddressUpdateRequired: !isBillingAddressValid,
        });
    }
},
);

replaceInChain(
    chain,
    AddOrUpdateShipTo,
    async props => 
        {

        const { dispatch, getState, cart } = props;
    const state = getState();
    const {
        context: {
            session: { fulfillmentMethod },
        },
        pages: {
            onePageCheckout: { shippingAddressFormState, isBillingAddressTheSameAsShipping },
        },
    } = state;
    if (!shippingAddressFormState ) { // || fulfillmentMethod !== FulfillmentMethod.Ship
        return;
    }

    const shipTo = getShipToState(state, cart.shipToId).value;
    const billTo = getBillToState(state, cart.billToId).value;
    if (!shipTo || !billTo) {
        throw new Error("There was no shipTo or billTo loaded for the current cart");
    }

    const { address: localModifiedShipTo } = shippingAddressFormState;
    if (isBillingAddressTheSameAsShipping && cart.shipToId !== cart.billToId && cart.billToId) {
        props.apiParameter.cart.shipToId = cart.billToId;
        const { shipToId } = props.apiParameter.cart;
        await makeHandlerChainAwaitable(loadShipTo)({ shipToId, billToId: cart.billToId, expand: ["validation"] })(
            dispatch,
            getState,
        );
        const shipToState = getShipToState(getState(), shipToId);
        shipToState.value &&
            props.dispatch({
                type: "Pages/OnePageCheckout/SetShippingAddress",
                address: shipToState.value,
            });
        return;
    }

    let updatedShipTo;
    // if (!isBillingAddressTheSameAsShipping && cart.shipToId === cart.billToId) {
    //     updatedShipTo = await createShipTo({ shipTo: localModifiedShipTo });
    // } else 
    if (!areAddressesTheSame(shipTo, localModifiedShipTo)) {
        updatedShipTo = await updateShipTo({ shipTo: localModifiedShipTo, billToId: billTo.id });
    }

    if (updatedShipTo) {
        props.updatedShipTo = { ...updatedShipTo, validation: shipTo.validation };
        dispatch(loadShipTo({ shipToId: props.updatedShipTo.id, billToId: billTo.id }));
        props.dispatch({
            type: "Pages/OnePageCheckout/SetShippingAddress",
            address: props.updatedShipTo,
        });
        props.apiParameter.cart.shipToId = props.updatedShipTo.id;
    }
    
     },
);